var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoCheckOver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.293 8.46329C25.424 8.32959 25.5804 8.22338 25.753 8.15087C25.9256 8.07836 26.1109 8.04102 26.2981 8.04102C26.4853 8.04102 26.6706 8.07836 26.8432 8.15087C27.0158 8.22338 27.1722 8.32959 27.3032 8.46329C27.8523 9.01817 27.86 9.91481 27.3224 10.4793L15.9695 23.9001C15.8406 24.0416 15.6841 24.1554 15.5098 24.2344C15.3354 24.3134 15.1467 24.356 14.9553 24.3596C14.7639 24.3632 14.5738 24.3277 14.3966 24.2553C14.2194 24.1829 14.0588 24.0751 13.9247 23.9385L7.01649 16.9382C6.75007 16.6665 6.60083 16.3011 6.60083 15.9206C6.60083 15.54 6.75007 15.1747 7.01649 14.903C7.14753 14.7693 7.30392 14.6631 7.4765 14.5906C7.64909 14.518 7.83441 14.4807 8.02161 14.4807C8.20882 14.4807 8.39414 14.518 8.56673 14.5906C8.73931 14.6631 8.8957 14.7693 9.02673 14.903L14.8866 20.8415L25.2546 8.50553L25.293 8.46329Z",
    fill: "#0C0C0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCheckOver);
export default __webpack_public_path__ + "static/media/NoCheckOver.a694dc2ab0e6555da9afc8c51f220063.svg";
export { ForwardRef as ReactComponent };